import LocalizedStrings from 'localized-strings';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    loading: 'Loading...',
  },
  fr: {
    loading: 'Chargement...',
  },
} as const);

export default locales;
